module.exports = __webpack_public_path__ + "img/icons-complaint_orange.8576cd9f.svg";